import 'css-chunk:src/components/pill/pill-component.module.scss';export default {
  "pill-component": "pill-component_pill-component__ZY-AY",
  "closable": "pill-component_closable__TWbVY",
  "disabled": "pill-component_disabled__xdgnd",
  "white": "pill-component_white__Vs6s3",
  "grey": "pill-component_grey__srgvg",
  "yellow": "pill-component_yellow__mPPMt",
  "blue": "pill-component_blue__QX2K5",
  "icon": "pill-component_icon__H5KI9",
  "close": "pill-component_close__G8oQ-",
  "on-click": "pill-component_on-click__uqMR5"
};